import { InvoiceTextCellKind } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import {
    ProInvoice,
    ProInvoiceColumns,
    ProInvoiceRowCreateRequest,
    ProInvoiceRowPatch,
    ProInvoiceTextRow,
} from "./interfaces";

const getColumns = (invoice: ProInvoice): ProInvoiceColumns => {
    const columns = invoice.columns.peek();

    if (!columns) {
        throw new Error("Invoice text is not opened");
    }

    return columns;
};

export const makeRow = ({ connection, company }: ApiSliceParams) => {
    const create = (
        invoice: ProInvoice,
        { data, after, before }: ProInvoiceRowCreateRequest,
    ) =>
        connection.value.proInvoiceText.row.create({
            company: company.value,
            invoice: invoice._id,
            after,
            before,
            data,
        });

    const update = (row: ProInvoiceTextRow, patch: ProInvoiceRowPatch) =>
        connection.value.proInvoiceText.row.update({
            company: company.value,
            id: row._id,
            etag: row.etag,
            ...patch,
        });

    const remove = (row: ProInvoiceTextRow) =>
        connection.value.proInvoiceText.row.delete({
            company: company.value,
            id: row._id,
            etag: row.etag,
        });

    const updateWidths = (invoice: ProInvoice, widths: number[]) =>
        connection.value.proInvoiceText.row.updateColumns({
            company: company.value,
            invoice: invoice._id,
            etag: getColumns(invoice).etag,
            widths,
        });

    const createColumn = (
        invoice: ProInvoice,
        kind: InvoiceTextCellKind,
        widths?: number[],
    ) =>
        connection.value.proInvoiceText.row.createColumn({
            company: company.value,
            invoice: invoice._id,
            etag: getColumns(invoice).etag,
            kind,
            widths,
        });

    const removeColumn = (
        invoice: ProInvoice,
        column: number,
        widths?: number[],
    ) =>
        connection.value.proInvoiceText.row.deleteColumn({
            company: company.value,
            invoice: invoice._id,
            etag: getColumns(invoice).etag,
            column,
            widths,
        });

    const setColumnKind = (
        invoice: ProInvoice,
        column: number,
        kind: InvoiceTextCellKind,
    ) =>
        connection.value.proInvoiceText.row.updateColumnKind({
            company: company.value,
            invoice: invoice._id,
            etag: getColumns(invoice).etag,
            column,
            kind,
        });

    const convert = (invoice: ProInvoice) =>
        connection.value.proInvoiceText.row.convert({
            company: company.value,
            id: invoice._id,
        });

    return {
        create,
        update,
        remove,
        updateWidths,
        createColumn,
        removeColumn,
        setColumnKind,
        convert,
    };
};
